import React from "react";
import styles from "./NumberInputWithButtons.module.scss";
import { MinusOnlyIcon, PlusOnlyIcon } from "../../../../assets/icons";

export type NumberInputWithButtonsVariant = "active" | "pending" | "failed" | "inactive";

interface NumberInputWithButtonsProps {
	value: number;
	showButtons: boolean;
	showClearButton: boolean;
	onNumberChange: (val: number) => void;
	className?: string;
	stepSize: number;
	minVal?: number;
	maxVal?: number;
	unit?: string;
	disabled?: boolean;
}

const NumberInputWithButtons: React.FC<NumberInputWithButtonsProps> = (props: NumberInputWithButtonsProps) => {
	const increaseValue = () => {
		let val = (props.value || 0) + props.stepSize;
		if (props.maxVal && val > props.maxVal) {
			val = props.maxVal;
		}
		props.onNumberChange(val);
	};
	const decreaseValue = () => {
		let val = (props.value || 0) - props.stepSize;
		if (props.minVal && val < props.minVal) {
			val = props.minVal;
		}
		props.onNumberChange(val);
	};

	const clearValue = () => {
		props.onNumberChange(0);
	};

	return (
		<div className={`${styles.numberInputWithButtons} `}>
			<div className={styles.numberDiv}>
				<input
					type="number"
					value={props.disabled ? "" : props.value}
					onChange={e => {
						let val = Number(e.target.value);
						if (props.maxVal && val > props.maxVal) {
							val = props.maxVal;
						}
						if (props.minVal && val < props.minVal) {
							val = props.minVal;
						}
						props.onNumberChange(val);
					}}
					disabled={props.disabled}
				/>
				{props.unit && <div className={styles.unit}>{props.unit}</div>}
			</div>
			<div className={`${styles.buttons} ${props.disabled ? styles.limited : styles.unLimited}`}>
				<div className={`${styles.iconBtn} ${styles.leftBtn}`} onClick={() => (!props.disabled ? increaseValue() : null)}>
					<PlusOnlyIcon />
				</div>
				<div className={`${styles.iconBtn} ${styles.rightBtn}`} onClick={() => (!props.disabled ? decreaseValue() : null)}>
					<MinusOnlyIcon />
				</div>
			</div>

			<div className={`${styles.buttons} ${props.disabled ? styles.limited : styles.unLimited}`}>
				<div className={styles.clearBtn} onClick={() => (!props.disabled ? clearValue() : null)}>
					<span>Clear</span>
				</div>
			</div>
		</div>
	);
};

export default NumberInputWithButtons;
